<template>
  <div>
    <div ref="pageTopAnchor" style="height:80px;margin-top:-80px;"></div>
    <div class="ceiling">
      <home-top></home-top>
      <top-search :showHot="true" type="home"></top-search>
      <navicat :current="6" background="#fff"></navicat>
    </div>
    <!-- 头部占位 -->
    <!-- <div class="h-top"></div> -->
    <!-- 身体部分 -->

    <div class="content">
      <div class="content-body w-1400">
        <div class="bread-crumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>行业工具</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="banner-box">
          <!--          v-loading="bannerLoading"-->
          <div class="banner-left">
            <div v-if="loadingMenu">
              <el-skeleton animated v-for="i in 7" :key="i">
                <template slot="template">
                  <div class="menu-item">
                    <el-skeleton-item style="width:24px; height:24px;border-radius: 50%; " variant="image"/>
                    <el-skeleton-item variant="text" class="card-right-title" style="height: 30px;width: 70%"/>
                  </div>
                </template>
              </el-skeleton>
            </div>
            <el-menu default-active="2" class="el-menu-vertical-demo" v-else >
              <el-menu-item v-for="(item, ind) in menuList" :key="ind" :index="toString(ind)"
                            @click="handleClick(ind, item.id)" :class="activeIndex == ind
                    ? 'banner-left-item-active'
                    : 'banner-left-item'
                  ">
                <!-- <img v-if=" activeIndex == ind"
                  :src="
                    require(`@/static/index/tool/tool-icon-active-` + ind + `.png`)
                  "
                  alt=""
                /> -->
                <img :src="item.image" alt=""/>
                <span slot="title">{{ item.cate_name }}</span>
              </el-menu-item>
            </el-menu>
          </div>

          <div class="banner-right">
            <div class="car-box" v-if="loading">
              <el-skeleton animated v-for="i in 12" :key="i">
                <template slot="template">
                  <div class="card-item">
                    <el-skeleton-item class="card-left-image" variant="image"/>
                    <div class="card-right">
                      <el-skeleton-item variant="text" class="card-right-title" style="height: 24px;"/>
                      <el-skeleton-item variant="text" class="card-right-desc" style="height: 16px;"/>
                    </div>
                  </div>
                </template>
              </el-skeleton>
            </div>
            <template v-else>
              <empty v-if="toolList.length == 0&&!loading"/>
              <div v-else class="car-box">
                <div class="card-item" v-for="item in toolList" :key="item.id" @click="handleTool(item)">
                  <div class="card-left-image">
                    <img :src="item.image" alt="缩略图"/>
                  </div>
                  <div class="card-right">
                    <div class="card-right-title"> {{ item.title }}</div>
                    <div class="card-right-desc">
                      {{ item.desc }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="pagination-box" v-if="toolList.length > 0">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                               :current-page="pageNum" :page-size="limit" background
                               layout="total,  prev, pager, next, jumper" :total="total">
                </el-pagination>
              </div>

            </template>

          </div>
        </div>
      </div>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import topSearch from "../../components/public/top-search.vue";
import homeFooter from "../../components/public/home-footer.vue";
import homeTop from "../../components/public/home-top.vue";
import navicat from "../../components/navicat/navicat.vue";
import empty from "../../components/public/empty.vue";
import {getToolCateList, getToolList} from "@/api/modules/home";
import HomeFooter from "../../components/public/home-footer.vue";

export default {
  name: "industry-tools",
  components: {HomeFooter, homeTop, navicat, empty, topSearch, homeFooter},
  data() {
    return {
      pageNum: 1,
      total: 0,
      id: '',
      activeIndex: 0,
      menuList: [],
      loadingMenu: true,
      limit: 12,
      toolList: [],
      loading: true,
      bannerLoading: true,
    };
  },
  created() {
    this.getToolCate();
  },
  methods: {
    // 获取行业工具分类
    getToolCate() {
      getToolCateList().then((res) => {
        this.menuList = res.data.data;
        this.loadingMenu=false
        this.handleClick(this.activeIndex, this.menuList[0].id);
        this.bannerLoading = false
      });
    },
    // 点击行业工具
    handleClick(ind, id) {
      this.id = id
      this.activeIndex = ind;
      this.pageNum = 0
      this.getTool();
    },
    // 获取行业工具
    getTool() {
      this.loading = true;
      getToolList(this.id, {limit: this.limit, page: this.pageNum}).then((res) => {
        this.toolList = res.data.data.data;
        this.total = res.data.data.total;
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      this.limit = val;
      this.getTool();

    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.$refs.pageTopAnchor?.scrollIntoView({behavior: 'auto', block: 'start'})
      this.getTool();
    },
    handleTool(item) {
      window.open(item.url, '_blank')
    }
  },
};
</script>
<style lang="scss" scoped>
.menu-item{
  display: flex;
  align-items: center;
  height: 89px;
  padding: 0 20px;
  justify-content: space-between;
}
.h-top {
  // height: 157px;
  //height: 80px;
  height: 265px;
}

.content {
  padding-bottom: 100px;

  .content-body {
    .bread-crumb {
      margin: 20px 0;
    }

    .top-ttle {
      padding: 50px 0 28px 258px;
      font-weight: bold;
      font-size: 24px;
      color: #00112b;
      font-weight: bold;
      font-size: 28px;
      color: #00112b;
    }

    .banner-box {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .banner-left {
        width: 258px;
        background: #ffffff;
        border-radius: 6px;
        min-height: 643px;

        .el-menu-vertical-demo {
          padding: 10px 0;
        }

        .banner-left-item {
          height: 89px;
          line-height: 89px;
          // font-weight: bold;
          font-size: 20px;
          color: #00112b;

          img {
            width: 24px;
            height: 24px;
            margin-right: 30px;
          }
        }

        .banner-left-item-active {
          height: 89px;
          line-height: 89px;
          // font-weight: bold;
          font-size: 20px;
          color: #ffffff;
          background: #4B87FF;

          img {
            width: 24px;
            height: 24px;
            margin-right: 30px;
          }
        }
      }

      .banner-right {
        position: relative;
        width: 1132px;
        height: 643px;
        background: #ffffff;
        border-radius: 6px 6px 6px 6px;

        .pagination-box {
          position: absolute;
          bottom: 0;
          width: 100%;
          padding: 25px;
          box-sizing: border-box;
          text-align: center;

        }

        .car-box {
          display: flex;
          //justify-content: space-between;
          flex-wrap: wrap;
          gap: 20px 11px;
          padding: 30px;

          .card-item {
            cursor: pointer;
            box-sizing: border-box;
            width: 350px;
            height: 106px;
            display: flex;
            align-items: center;
            padding: 15px;
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #eef0f5;

            .card-left-image {
              width: 76px;
              height: 76px;
              background: #d8d8d8;
              margin-right: 20px;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .card-right {

              display: flex;
              flex-direction: column;
              justify-content: space-between;

              .card-right-title {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                // font-weight: bold;
                font-size: 18px;
                color: #00112b;
                width: 224px;
                margin-bottom: 10px;
              }

              .card-right-desc {
                width: 224px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-weight: 400;
                font-size: 16px;
                color: #5f616c;
              }
            }
          }
        }
      }
    }
  }
}
</style>
